import React from 'react';
import { Link } from 'react-router-dom';

const Career = () => {
    return (
        <section id="career" className="career">
            <h2>Currently, I work</h2>
            <div>
                <p>@ the <Link  to="https://piechlab.stanford.edu/" className="custom-link">
                        Piech Lab
                    </Link> researching educational technology</p>
                <p>@ the Advanced Financial Technologies Lab solving equations</p>  
                <p>
                    @ <Link  to="https://www.diversifyournarrative.com/" className="custom-link">
                        Diversify Our Narrative
                    </Link> building educational tools
                </p>
            </div>
        </section>
    );
};

export default Career;
